// Imports
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const slice = createSlice({
  name: '$enableAdvancedCustomHours',
  initialState,
  reducers: {
    setEnableAdvancedCustomHours(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableAdvancedCustomHours } = slice.actions;
export default slice.reducer;
